export default ({ FONT_SIZES }) => ({
  container: {
    width: '100%',
    height: '100%'
  },
  note: {
    ...FONT_SIZES.HEADING_MEDIUM.STYLE,
    margin: '0',
    paddingRight: '200px',
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      padding: '20px',
      display: 'none'
    }
  },
  controls: {
    position: 'absolute',
    top: '0',
    right: '0',
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      top: 'auto',
      bottom: '15px',
      right: '90px'
    }
  },
  footer: {
    position: 'relative',
    marginTop: '30px',
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      margin: '0',
      position: 'static'
    }
  },
  slide: {
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      padding: '0',
      height: '100%'
    }
  },
  infoOpened: {
    '& $slide': {
      [`@media (max-width: 920px) and (orientation: landscape)`]: {
        display: 'none'
      }
    },
    '& $note': {
      [`@media (max-width: 920px) and (orientation: landscape)`]: {
        display: 'block'
      }
    }
  }
})
